<div class="pj-pending-modal">
    <div class="modal-icon-wrapper">
        <div class="icon-circle">
            <mat-icon>hourglass_top</mat-icon>
        </div>
    </div>

    <h2>Transação enviada para aprovação</h2>
    <p class="description">
        Sua solicitação foi registrada e está aguardando a aprovação de um responsável da conta.
    </p>

    <div class="request-info">
        <div class="info-row">
            <mat-icon>tag</mat-icon>
            <span class="label">Protocolo:</span>
            <span class="value">{{ data.requestId | slice:0:8 }}...</span>
        </div>
        <div class="info-row">
            <mat-icon>pending_actions</mat-icon>
            <span class="label">Status:</span>
            <span class="value status-badge">Aguardando Aprovação</span>
        </div>
    </div>

    <div class="modal-actions">
        <button mat-stroked-button (click)="goToRequests()">
            <mat-icon>list_alt</mat-icon>
            Ver Solicitações
        </button>
        <button mat-raised-button color="primary" (click)="close()">
            Entendi
        </button>
    </div>
</div>
